<template>
    <footer class="sticky--footer" :class="{'sticky--footer--animate--top': expand}" v-if="show">
        <div class="container">
            <div class="row align-items-center">
                <div class="col text-right">
                    <h4 class="sticky--footer--total">
                        <span v-text="getTranslation('totalLabel')"></span>
                        <small class="d-block">{{ total | currency }}</small>
                    </h4>
                </div>
                <div class="col text-center">
                    <button class="btn btn-primary btn-lg sticky--footer--pay" @click="toCheckout" v-text="getTranslation('payLabel')"></button>
                </div>
                <div class="col d-flex no-wrap sticky--footer--cart">
                    <div class="d-inline-block sticky--footer--cart--container" @click="toggle">
                        <icon-base :view-box-height="200" :view-box-width="200" :icon-color="'#fff'" :height="40"
                                   :width="40" :class="['align-middle', 'sticky--footer--cart']">
                            <shopping-cart-icon/>
                        </icon-base>

                        <span class="sticky--footer--cart--counter">{{ count }}</span>
                    </div>

                    <div class="d-inline-block cursor-pointer" @click="toggle">
                        <icon-base :view-box-height="512"
                               :view-box-width="320"
                               :width="30"
                               icon-color="#fff"
                               :height="30"
                               :class="classes">
                        <sort-down-icon @click="toggle"></sort-down-icon>
                    </icon-base>
                    </div>
                </div>
            </div>
        </div>

        <div class="container footer--cart--details mt-3">
            <div v-if="products.length">
                <cart-ticket-passes v-for="(product, index) in products" :product="product" :index="index" :key="product.key ? product.key : product.product_id" v-if="product.quantity"/>
            </div>
            <div v-else>
                <h4 class="text-center mt-4" v-text="getTranslation('emptyCartLabel')"></h4>
            </div>
        </div>
    </footer>
</template>

<script>
    import CartTicketPasses from './CartTicketPasses';
    import * as Actions from '../store/action-types';
    import passescartMixin from '../mixins/passescartMixin';
    import siteConfig from '../mixins/siteConfig';

    export default {
        components: {
            CartTicketPasses
        },

        mixins: [passescartMixin, siteConfig],

        methods: {
            toggle() {
                this.$store.dispatch(Actions.toggleFooter);
            },

            toCheckout: function () {
                const uuid = window.localStorage.getItem('passes_cart');
                const params = uuid ? `${uuid}/` : '';
                window.location.href = `${this.getUrl('confirmpassesUrl')}${params}`;
            }
        },

        computed: {
            show() {
                if (window.location.pathname === '/') {
                    return this.products.length;
                }

                return true;
            },

            classes() {
                const baseClass = 'fix--ticket--toggle--icon sticky--footer--arrow';

                return !this.expand
                    ? [baseClass]
                    : [baseClass, 'active'];
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/StickyFooterPasses.vue